import React, { FC } from 'react'
import classNames from 'classnames'
import { useInView } from 'react-intersection-observer'
import { slugs } from '@/constants/slugs'
import { CutoutSection } from '@/views/PreSales/PreSalesGiveawayView/components/Content/CutoutSection'
import { HowItWorks } from '@/views/PreSales/PreSalesGiveawayView/components/Content/HowItWorks'
import { LevelUp } from '@/views/PreSales/PreSalesGiveawayView/components/Content/LevelUp'
import { PartnerLogosSection } from '@/views/PreSales/PreSalesGiveawayView/components/Content/PartnerLogosSection'
import { SketchBanner } from '@/views/PreSales/PreSalesGiveawayView/components/Content/SketchBanner'
import TicketPackSection from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/TicketPackSection'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'

const MobileTicketSection: FC = () => {
  const { isActive, tickets, entryVariantId, mobileTicketContainerRef } = useGiveawayContext()

  const { ref: mobileProductRef } = useInView({ threshold: 0 })

  if (!isActive || !tickets || !entryVariantId) {
    return null
  }

  return (
    <TicketPackSection
      ref={mobileTicketContainerRef}
      className="w-full overflow-y-auto bg-white md:bg-[#F5F5F5] lg:hidden"
      mobileProductRef={mobileProductRef}
    />
  )
}

const ContentSections: React.FC<{ hasUser?: boolean }> = ({ hasUser }) => {
  const { isActive, giveawayData, theatricalSlug, experiments } = useGiveawayContext()
  const { steps, partnerLogos } = giveawayData
  const partnerExperiment = experiments?.['sketch-giveaway-partner-section']

  const renderContent = () => {
    if (!isActive) return null

    const experiment = partnerExperiment || 'Default'

    switch (experiment) {
      case 'Freddie':
        return (
          <>
            {steps && <LevelUp className={partnerLogos ? '!pb-0' : undefined} steps={steps} />}
            {partnerLogos && <CutoutSection partnerLogos={partnerLogos} />}
          </>
        )
      case 'Promo':
        return (
          <>
            {steps && <LevelUp className={partnerLogos ? '!pb-0' : undefined} steps={steps} />}
            {partnerLogos && <SketchBanner />}
          </>
        )
      case 'Default':
      default:
        return (
          <>
            {steps && <HowItWorks hasUser={hasUser} className={partnerLogos ? '!pb-0' : undefined} steps={steps} />}
            {partnerLogos && <PartnerLogosSection partnerLogos={partnerLogos} />}
          </>
        )
    }
  }

  return (
    <div
      className={classNames(
        'px-4 md:px-12',
        theatricalSlug === slugs.sketch && 'bg-gradient-to-b from-[rgba(7,84,237,0.06)] to-transparent bg-white',
      )}
    >
      {renderContent()}
    </div>
  )
}

export const GiveawayContent: React.FC<{ hasUser?: boolean }> = ({ hasUser }) => {
  return (
    <>
      <MobileTicketSection />
      <ContentSections hasUser={hasUser} />
    </>
  )
}
